module.exports = __webpack_public_path__ + "img/glass_laminated.3f8b769.svg";